import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
export const pricingPageData = {
    pricingPlansTable: [[
        { label: "Verð á mánuði" },
        { label: "0 kr." },
        { label: "4.900 kr." },
        { label: "Umsamið" }
    ], [
        { label: "Fjöldi aðganga" },
        { label: "1" },
        { label: "4" },
        { label: "Umsamið" }
    ], [
        { label: "Vakta fyrirtæki" },
        { label: "" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Fréttavakt" },
        { label: "" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Skannaðir ársreikningar" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Aðgangur að gögnum úr ársreikningum" },
        { label: "" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Hlutafélagaskrá" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Eignarhald í öðrum félögum" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Hlutafélagaþáttaka" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Skönnuð skjöl (samþykktir, stofnskjöl o.fl.)" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Þjóðskrá" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Lögbirtingar" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/>}
    ], [
        { label: "Eignaleit - fasteignir" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Eignaleit - ökutæki og vinnuvélar" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Eignaleit - veðbönd" },
        { label: "" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Raunverulegir eigendur" },
        { label: "" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> }
    ], [
        { label: "Samanburðar skýrsla" },
        { label: "" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/>}
    ], [
        { label: "Verðmat fyrirtækja" },
        { label: "" },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/> },
        { label: <FontAwesomeIcon icon={faCheck} className="icon-fa-check"/>}
    ]]
}